import { Box, Button, Paper, Typography } from "@material-ui/core";
import { useDialogProps } from "legacy-components/dialog/Dialog";
import AddIcon from "@material-ui/icons/Add";

import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { ApplicationThrottlingListView } from "./ApplicationThrottlingListView";
import { ApplicationThrottlingDialog } from "./ApplicationThrottlingDialog";
export interface IApplicationThrottling {
  consumerKey: string;
  applicationName: string;
  applicationType: string;
  teamName: string;
  accountName: string;
  spikeArrestLimit: number;
  spikeArrestTimeunit: "ps" | "pm" | string; // Use string unions if units are known
}

interface ThrottlingDetailsProps {
  deploymentId: string;
  deployStatus?: string;
  refreshDeploymentList: () => void;
  applicationThrottling?: IApplicationThrottling[];
  subscribedApps?: Record<string, string>;
  /** When true, use appthrottlingV2 (regional-safe redeploy). */
  useApplicationThrottlingV2?: boolean;
}

export const ApplicationThrottlingDetails: React.FC<ThrottlingDetailsProps> =
  React.memo((props) => {
    const { open, toggle } = useDialogProps();

    const existingThrottlingKeys = useMemo(() => {
      return new Set(
        props.applicationThrottling?.map((item) => item.consumerKey) || [],
      );
    }, [props.applicationThrottling]);

    const availableAppsMap = useMemo(() => {
      if (!props.subscribedApps) return {};

      const filteredMap: Record<string, string> = {};

      Object.entries(props.subscribedApps).forEach(([key, name]) => {
        if (!existingThrottlingKeys.has(key)) {
          filteredMap[key] = name;
        }
      });

      return filteredMap;
    }, [props.subscribedApps, existingThrottlingKeys]);

    return (
      <Paper style={{ width: "100%", padding: "20px" }}>
        <Box display="flex" justifyContent="space-between">
          <Typography
            variant="body1"
            style={{ padding: "20px", fontWeight: 600 }}
          >
            <FormattedMessage defaultMessage="Client based Rate Limits" />
          </Typography>
          <Button
            startIcon={<AddIcon />}
            variant="outlined"
            color="primary"
            size="large"
            style={{ padding: "10px 21px", borderRadius: 0, marginTop: "15px" }}
            onClick={toggle}
            disabled={props?.deployStatus !== "DEPLOY_COMPLETED"}
          >
            <FormattedMessage defaultMessage="Add Client Based Rate Limits" />
          </Button>
        </Box>
        <ApplicationThrottlingListView
          deploymentId={props.deploymentId}
          refresh={props.refreshDeploymentList}
          appThrottlingList={props.applicationThrottling}
          deployStatus={props.deployStatus}
          useApplicationThrottlingV2={props.useApplicationThrottlingV2}
        ></ApplicationThrottlingListView>
        <ApplicationThrottlingDialog
          deploymentId={props.deploymentId}
          open={open}
          toggle={toggle}
          consumerKeyAppNameMap={availableAppsMap}
          refresh={props.refreshDeploymentList}
          useApplicationThrottlingV2={props.useApplicationThrottlingV2}
        ></ApplicationThrottlingDialog>
      </Paper>
    );
  });
